import CheckCircleOutline from "@mui/icons-material/CheckCircleOutline";
import { colors } from "healthex-common/colors";
import styled from "styled-components";
import { HXTextField } from "./base.styles";
import { FlexColumnDiv } from "./common.styles";
export const ForgotPasswordForm = styled(FlexColumnDiv) `
    gap: 40px;
`;
export const GenericText = styled.div `
    & li {
        margin-bottom: 10px;
    }
    &:not(:first-child) {
        margin-top: 20px;
        margin-bottom: 30px;
    }
`;
export const EMailTextField = styled(HXTextField) `
    width: 100%;
`;
export const SuccessIcon = styled(CheckCircleOutline) `
    color: ${colors.forest_main};
    width: 36px;
    height: 36px;
`;
